import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import RelatorioFaturamentoCartaoFidelidadeFiltro from '../../../../models/relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fideliade-filtro.model';
import { RelatorioFaturamentoCartaoFidelidaeDetalhe } from '../../../../models/relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fidelidade-detalhe.model';
import { LoadingService } from '../../../../util/loader.service';
import { RelatorioFaturamentoCartaoFidelidadeService } from '../relatorio-faturamento-cartao-fidelidade.service';

@Component({
  selector: 'app-relatorio-faturamento-cartao-fidelidade-detalhes',
  templateUrl: './relatorio-faturamento-cartao-fidelidade-detalhes.component.html',
  styleUrls: ['./relatorio-faturamento-cartao-fidelidade-detalhes.component.scss']
})
export class RelatorioFaturamentoCartaoFidelidadeDetalhesComponent implements OnInit {
  record: RelatorioFaturamentoCartaoFidelidaeDetalhe;
  filtro: RelatorioFaturamentoCartaoFidelidadeFiltro;
  constructor(public service: RelatorioFaturamentoCartaoFidelidadeService,
    fb: FormBuilder, public loader: LoadingService,
    private route: ActivatedRoute,
    private router: Router) {
    this.record = new RelatorioFaturamentoCartaoFidelidaeDetalhe();
    this.filtro = new RelatorioFaturamentoCartaoFidelidadeFiltro();
    this.route.queryParams.subscribe(params => {
      const record = JSON.parse(params['data']);

      debugger;
      this.filtro = record as RelatorioFaturamentoCartaoFidelidadeFiltro;
      this.service.detalhe(this.filtro).subscribe(item => {
        debugger;
        this.record = item;
      });
    });
  }

  ngOnInit() {
  }
  voltar() {
    this.router.navigate(['/fidel/relatorio-faturamento-cartao-fidelidade']);
  }
}
